import NavigationBar from 'carbon-react/esm/components/navigation-bar';
import { Menu } from 'carbon-react/esm/components/menu';
import { useLocation } from 'react-router-dom';
import { useAuthAppContext } from '../context/useAuthAppContext';
import { AppRoutes } from '../types/appRoutes';
import MenuItemWithReactRouter from './MenuItemWithReactRouter';
import { useUserInfos } from '../hooks/useUserInfos';

interface PagesNavigationBarComponentProps {
  readonly isLoading?: boolean;
}

export default function PagesNavigationBarComponent({
  isLoading = false,
}: PagesNavigationBarComponentProps) {
  const { isAuthenticated } = useAuthAppContext();
  const { hasRole, isRegistered } = useUserInfos();
  const location = useLocation();
  const isDsnListPage = location.pathname === AppRoutes.routeDsnList;
  const isAdminPage = location.pathname.startsWith(AppRoutes.routeAdmin);

  const canViewAdmin = isAuthenticated && hasRole(['admin']) && isRegistered();

  return (
    <NavigationBar
      position="sticky"
      orientation="top"
      offset="47px"
      variant="white"
      isLoading={isLoading}
    >
      <Menu menuType="white">
        {/* <MenuItem href={AppRoutes.routeDsnList} selected={isDsnListPage}> */}
        <MenuItemWithReactRouter to={AppRoutes.routeDsnList} selected={isDsnListPage}>
          Flux DSN
        </MenuItemWithReactRouter>
        {canViewAdmin && (
          <MenuItemWithReactRouter to={AppRoutes.routeAdmin} selected={isAdminPage}>
            Administration
          </MenuItemWithReactRouter>
        )}
      </Menu>
    </NavigationBar>
  );
}
